import { crudOperations } from './api';

const appointmentService = {
  /**
   * Get appointments for a franchisee with optional filters
   * @param {string} franchiseeId - The franchisee ID
   * @param {Object} params - Query parameters
   * @returns {Promise} Appointment data with pagination
   */
  async getAppointments(franchiseeId, params = {}) {
    try {
      const queryParams = {};

      // Add pagination
      if (params.page) queryParams.page = params.page;
      if (params.limit) queryParams.limit = params.limit;

      // Add filters
      if (params.job_id) queryParams.job_id = params.job_id;
      if (params.status) queryParams.status = params.status;
      if (params.appointment_type) queryParams.appointment_type = params.appointment_type;
      if (params.assigned_technician_id) queryParams.assigned_technician_id = params.assigned_technician_id;
      if (params.branch_id) queryParams.branch_id = params.branch_id;
      if (params.date_from) queryParams.date_from = params.date_from;
      if (params.date_to) queryParams.date_to = params.date_to;
      if (params.overdue) queryParams.overdue = params.overdue;

      // Add sorting
      if (params.sortBy) queryParams.sortBy = params.sortBy;
      if (params.sortOrder) queryParams.sortOrder = params.sortOrder;

      const response = await crudOperations.get(`/appointments/${franchiseeId}`, queryParams);
      return response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },

  /**
   * Create a new appointment
   * @param {string} franchiseeId - The franchisee ID
   * @param {Object} appointmentData - Appointment data
   * @returns {Promise} Created appointment
   */
  async createAppointment(franchiseeId, appointmentData) {
    try {
      const response = await crudOperations.post(`/appointments/${franchiseeId}`, appointmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating appointment:', error);
      throw error;
    }
  },

  /**
   * Update an existing appointment
   * @param {string} franchiseeId - The franchisee ID
   * @param {string} appointmentId - The appointment ID
   * @param {Object} updateData - Updated appointment data
   * @returns {Promise} Update confirmation
   */
  async updateAppointment(franchiseeId, appointmentId, updateData) {
    try {
      const response = await crudOperations.put(`/appointments/${franchiseeId}/${appointmentId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Error updating appointment:', error);
      throw error;
    }
  },

  /**
   * Get appointment status counts
   * @param {string} franchiseeId - The franchisee ID
   * @returns {Promise} Status counts object
   */
  async getAppointmentCounts(franchiseeId) {
    try {
      const response = await crudOperations.get(`/appointments/${franchiseeId}/counts`);
      return response.data;
    } catch (error) {
      console.error('Error fetching appointment counts:', error);
      throw error;
    }
  },

  /**
   * Delete an appointment
   * @param {string} franchiseeId - The franchisee ID
   * @param {string} appointmentId - The appointment ID
   * @returns {Promise} Deletion confirmation
   */
  async deleteAppointment(franchiseeId, appointmentId) {
    try {
      const response = await crudOperations.delete(`/appointments/${franchiseeId}/${appointmentId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting appointment:', error);
      throw error;
    }
  }
};

export default appointmentService;
